export default {
  inviteOrganization: 'INVITE_ORGANIZATION',
  organizationProfile: 'ORGANIZATION_PROFILE'
}